import React, { createContext, useCallback, useContext, useMemo, useState } from 'react'

const Context = createContext({
    credicard: null,
    errors: {},
    setCredicard: () => { throw new Error("Contexto não atribuido.") },
    handleAddErrors: () => { throw new Error("Contexto não atribuido.") },
    handleRemoveErrors: () => { throw new Error("Contexto não atribuido.") },
    clearCredicard: () => { throw new Error("Contexto não atribuido.") },
})

export const useCheckoutProvider = () => useContext(Context)

const CheckoutProvider = ({ children }) => {
    const [credicard, setCredicard] = useState(null)
    const [usedPoints, setUsedPoints] = useState(null);
    const [errors, setErrors] = useState({})

    const handleAddErrors = useCallback((index, value) => {
        setErrors(prevErrors => ({
            ...prevErrors,
            [index]: value
        }));
    }, []);

    const handleRemoveErrors = useCallback((index) => {
        const newErrors = { ...errors }
        if (newErrors[index]) delete newErrors[index]
        setErrors(newErrors)
    }, [errors])

    const handleSetCredicard = useCallback((value) => {
        setCredicard({
            ...(credicard || {}),
            ...value,
        })
    }, [credicard])

    const handleUsedPointsChange = (value) => {
        setUsedPoints(value);
    }

    const clearCredicard = useCallback(() => {
        setCredicard(null)
    }, [credicard])

    const value = useMemo(() => ({
        credicard,
        clearCredicard,
        setCredicard: handleSetCredicard,
        handleUsedPointsChange,
        usedPoints,
        handleRemoveErrors,
        handleAddErrors,
        errors
    }), [
        credicard,
        handleSetCredicard,
        handleUsedPointsChange,
        usedPoints,
        handleRemoveErrors,
        handleAddErrors,
        clearCredicard,
        errors
    ])

    return (
        <>
            <Context.Provider value={value}>
                {children}
            </Context.Provider>
        </>
    )
}

export default CheckoutProvider
